import * as yup from "yup";

const goalSchema = yup.object().shape({
  firstGoal: yup.string(),
  secondGoal: yup.string(),
  thirdGoal: yup.string(),
});

export default goalSchema;
